module.exports = __webpack_public_path__ + "img/active_icon02.3657a3d6.png";